import { render, staticRenderFns } from "./InputForm.vue?vue&type=template&id=ed271b1a&scoped=true"
import script from "./InputForm.vue?vue&type=script&lang=js"
export * from "./InputForm.vue?vue&type=script&lang=js"
import style0 from "./InputForm.vue?vue&type=style&index=0&id=ed271b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed271b1a",
  null
  
)

export default component.exports